import { render, staticRenderFns } from "./SmsNew.vue?vue&type=template&id=13287bf2&scoped=true"
import script from "./SmsNew.vue?vue&type=script&lang=js"
export * from "./SmsNew.vue?vue&type=script&lang=js"
import style0 from "./SmsNew.vue?vue&type=style&index=0&id=13287bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13287bf2",
  null
  
)

export default component.exports